/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ErrorLogCompassDeleteAllObjects
 */
export interface ErrorLogCompassDeleteAllObjects {
    /**
     * 
     * @type {string}
     * @memberof ErrorLogCompassDeleteAllObjects
     */
    firmware_version: string;
}

/**
 * Check if a given object implements the ErrorLogCompassDeleteAllObjects interface.
 */
export function instanceOfErrorLogCompassDeleteAllObjects(value: object): value is ErrorLogCompassDeleteAllObjects {
    if (!('firmware_version' in value) || value['firmware_version'] === undefined) return false;
    return true;
}

export function ErrorLogCompassDeleteAllObjectsFromJSON(json: any): ErrorLogCompassDeleteAllObjects {
    return ErrorLogCompassDeleteAllObjectsFromJSONTyped(json, false);
}

export function ErrorLogCompassDeleteAllObjectsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorLogCompassDeleteAllObjects {
    if (json == null) {
        return json;
    }
    return {
        
        'firmware_version': json['firmware_version'],
    };
}

export function ErrorLogCompassDeleteAllObjectsToJSON(json: any): ErrorLogCompassDeleteAllObjects {
    return ErrorLogCompassDeleteAllObjectsToJSONTyped(json, false);
}

export function ErrorLogCompassDeleteAllObjectsToJSONTyped(value?: ErrorLogCompassDeleteAllObjects | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firmware_version': value['firmware_version'],
    };
}

